import { createContext } from "react";

export interface ISquareContext {
    isLoading: boolean;
    setIsLoading: (value: boolean) => void;
    nextSlide: () => void;
    prevSlide: () => void;
    processingCompleted: boolean;
    setProcessingCompleted: (value: boolean) => void;
}

export const SquareContext = createContext<ISquareContext>({});